import { msg } from "@lingui/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { Screen } from "../../state/screen";
import type { TutorialHintId } from "../../state/tutorialStore";
import type { PointerSide } from "./tutorialSteps";

export interface TutorialHint {
  id: TutorialHintId;
  screen: Screen;
  targetId: string;
  title: MessageDescriptor;
  body: MessageDescriptor;
  pointerSide: PointerSide;
}

/**
 * One-off coachmarks shown the first time the player opens a progression
 * screen outside the guided first contract.
 */
export const TUTORIAL_HINTS: readonly TutorialHint[] = [
  {
    id: "skills",
    screen: "skills",
    targetId: "skill-card",
    title: msg`Экран навыков`,
    body: msg`Здесь вкладываешь очки навыка - прокачка облегчает задачи. Появятся очки (за новые уровни) - загляни сюда.`,
    pointerSide: "right",
  },
  {
    id: "tools",
    screen: "tools",
    targetId: "tool-card",
    title: msg`Магазин инструментов`,
    body: msg`За деньги тут покупаешь инструменты - каждый помогает в своей задаче: где-то подскажет, где-то упростит проверку. Что делает - смотри в описании. Накопишь - возвращайся.`,
    pointerSide: "right",
  },
];
